module.exports = __webpack_public_path__ + "img/finance_pay_oil_on.987ad61c.png";